var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMembers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4018_194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1868 13.1574H0V0H13.1868V13.1574ZM12.0879 1.09645H1.0989V12.0609H12.0879V1.09645ZM9.82418 8.80447C8.56593 8.51391 7.39011 8.25624 7.96154 7.19269C9.68681 3.93624 8.41758 2.19289 6.59341 2.19289C4.76923 2.19289 3.49451 4.00203 5.22528 7.19269C5.81319 8.28914 4.59341 8.52487 3.36264 8.80447C2.23626 9.06761 2.1978 9.62132 2.1978 10.5972V10.9645H10.989V10.6081C10.989 9.6268 10.956 9.06761 9.82418 8.80447Z",
    fill: "#93C11A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9998 13.1574H13.813V0H26.9998V13.1574ZM25.9009 1.09645H14.9119V12.0609H25.9009V1.09645ZM23.6262 8.80447C22.3679 8.51391 21.1921 8.25624 21.7635 7.19269C23.4998 3.93624 22.2306 2.19289 20.4064 2.19289C18.5822 2.19289 17.3075 4.00203 19.0383 7.19269C19.6262 8.28914 18.4064 8.52487 17.1756 8.80447C16.0493 9.06761 16.0053 9.62132 16.0108 10.5972V10.9645H24.802V10.6081C24.8075 9.6268 24.769 9.06761 23.6262 8.80447Z",
    fill: "#93C11A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1868 27.0011H0V13.8438H13.1868V27.0011ZM12.0879 14.9402H1.0989V25.9047H12.0879V14.9402ZM9.82418 22.6537C8.56593 22.3631 7.39011 22.1055 7.96154 21.009C9.68681 17.7526 8.41758 16.0092 6.59341 16.0092C4.76923 16.0092 3.49451 17.8184 5.22528 21.009C5.81319 22.1055 4.59341 22.3412 3.36264 22.6537C2.23626 22.9114 2.1978 23.4706 2.1978 24.4464V24.8082H10.989V24.4574C10.989 23.476 10.956 22.9114 9.82418 22.6537Z",
    fill: "#93C11A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9998 27.0011H13.813V13.8438H26.9998V27.0011ZM25.9009 14.9402H14.9119V25.9047H25.9009V14.9402ZM23.6262 22.6537C22.3679 22.3631 21.1921 22.1055 21.7635 21.009C23.4888 17.7526 22.2196 16.0092 20.3954 16.0092C18.5712 16.0092 17.2965 17.8184 19.0273 21.009C19.6152 22.1055 18.3954 22.3412 17.1646 22.6537C16.0383 22.9114 15.9943 23.4706 15.9998 24.4464V24.8082H24.791V24.4574C24.8075 23.476 24.769 22.9114 23.6262 22.6537Z",
    fill: "#93C11A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4018_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.b3d6ef3665d5d1baa3ddf14665bea934.svg";
export { ForwardRef as ReactComponent };